import React, { useState, useEffect } from "react";
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import UpperProgressBar from "../components/common-components/UpperProgressBar";
import RightSidebar from "../components/common-components/right_sidebar";
import TextField from "@mui/material/TextField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import studentServices from "../services/student.services";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import LoadingBar from "../components/common-components/toaster/loader/loader";
import StudentDocView from "../components/common-components/studentInfo/studentDocsView";

const StudentInfo2 = () => {
    const [booster, setBooster] = useState(false)
    const [Fieldval, SetFieldVal] = useState({
        physical_cleared_proof: [], cpr_proof: [], complete_background_check_proof: [], took_drug_test_proof: [],
        flu_vaccine_proof: [], td_xray: [], td_document: [], mmr_booster_dose2_proof: [], varicella_booster_dose2_proof: [], hep_b_booster_dose2_proof: [],
        hep_b_booster_dose3_proof: [], covid_proof: [], la_fire_safety_proof: [], additional_info_proof: [], additional_info_proof2: [], additional_info_proof3: []
    })
    const navigate = useNavigate()
    const [loading, setload] = useState(false)

    const handleCheckBox = (e) => {
        const name = e.target.name
        var value = e.target._valueTracker.getValue()
        value = value === "true" ? true : false
        SetFieldVal({
            ...Fieldval,
            [name]: value
        })
    }
    async function getStudentProfile() {
        await studentServices.getStudentProfile().then((resp) => {
            SetFieldVal(prev => ({ ...prev, ...resp.data.data.studentinfo }))
            // SetFieldVal(prev=>({...prev , ...resp.data.data.studentinfo}))
        }).catch(err => console.log(err, "<--- Err"))
    }

    useEffect(() => {
        getStudentProfile()
    }, [])

    const handleFieldValue = (e) => {
        const name = e.target.name
        const value = e.target.value
        SetFieldVal({
            ...Fieldval,
            [name]: value
        })
    }

    const handleDocUpload = (e) => {
        setload(!loading)
        const name = e.target.name
        const file = e.target.files[0];

        const obj = {
            document: file,
            doc_type: name === 'physical_cleared_proof' ? "physically_cleared" :
                name === "cpr_proof" ? "cpr" :
                    name === "complete_background_check_proof" ? "background_check_proof" :
                        name === "took_drug_test_proof" ? "drug_test_proof" :
                            name === "flu_vaccine_proof" ? "flu_vaccine_proof" :
                                name === "td_xray" ? "tb_xray" :
                                    name === 'td_document' ? "tb_doc" :
                                        name === "mmr_booster_dose2_proof" ? "mmr_proof" :
                                            name === "varicella_booster_dose2_proof" ? "varicella_proof" :
                                                name === "hep_b_booster_dose2_proof" ? "hep_b_proof" :
                                                    name === "hep_b_booster_dose3_proof" ? "hep_b_proof" :
                                                        name === "covid_proof" ? "covid_19" :
                                                            name === "la_fire_safety_proof" ? "LA_fire_safety_proof" :
                                                                name === "additional_info_proof" ? "additional_proof" :
                                                                    name === "additional_info_proof2" ? "additional_proof" :
                                                                        name === "additional_info_proof3" ? "additional_proof" : ""
        };
        const form_data = new FormData();
        for (var key in obj) {
            form_data.append(key, obj[key]);
        }
        studentServices.uploadStudentDoc(form_data)
            .then(resp => {
                setload(false)
                Fieldval[name].push({ file: resp.data, date: new Date })
                // SetFieldVal({
                //     ...Fieldval,
                //     [name]: resp.data
                // })
            })
            .catch(err => setload(false))

    }

    const updateMyBio = (e) => {
        setload(!loading)
        studentServices.UpdateStudentData(Fieldval)
            .then(resp => {
                setload(false)
                navigate('/student-info3')

            })
            .catch(err => setload(false))
        e.preventDefault()
    }


    return (
        <div className="signup_pg">
            <Container fluid>
                {loading &&
                    <LoadingBar />
                }
                <div className="signup_pg_wrap">
                    <Row className="justify-content-center align-items-start">
                        <Col md={6}>
                            <UpperProgressBar step={4} />
                            <div className="signup_form">
                                <div className="sign_hdng">
                                    <h2>Other Information</h2>
                                </div>
                                <Form onSubmit={(e) => { updateMyBio(e) }} className="signform_div">
                                    <div className="info_div">
                                        <h5>Physical Examination</h5>
                                        <Form.Group
                                            className="mb-3"
                                        // controlId="formBasicCheckbox"
                                        >
                                            <Form.Check type="checkbox">
                                                <Form.Check.Input checked={Fieldval?.declare_physical_cleared ? true : false} type="checkbox" name="declare_physical_cleared" onChange={(e) => { handleCheckBox(e) }} />
                                                <Form.Check.Label>
                                                    I declare that I am
                                                    Physically cleared.
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </Form.Group>
                                        {Fieldval.declare_physical_cleared &&
                                            <>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    <Form.Label>
                                                        Upload Proof
                                                    </Form.Label>
                                                    {Fieldval.physical_cleared_proof.length > 0 &&
                                                        <StudentDocView MapData={Fieldval.physical_cleared_proof} type='physically_cleared' />}
                                                    <Form.Control name='physical_cleared_proof' type="file" onChange={(e) => { handleDocUpload(e) }}
                                                        required={Fieldval.declare_physical_cleared && Fieldval.physical_cleared_proof.length === 0 && true}
                                                    />
                                                    <Form.Text className="text-muted">
                                                        It is valid for an year after
                                                        upload.
                                                    </Form.Text>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterMoment}

                                                    >
                                                        <Form.Label>
                                                            Date when physical conducted
                                                        </Form.Label>
                                                        <DatePicker
                                                            value={Fieldval.physical_cleared_conducted ? Fieldval.physical_cleared_conducted : null}
                                                            placeholder="Enter Date when physical conducted"
                                                            className="form-control"
                                                            name='physical_cleared_conducted'
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                newValue &&
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "physical_cleared_conducted": newValue._d
                                                                    })
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    error={Fieldval.physical_cleared_proof && !Fieldval.physical_cleared_conducted && true}
                                                                    helperText={Fieldval.physical_cleared_proof && !Fieldval.physical_cleared_conducted && "*required"}
                                                                    required={Fieldval.physical_cleared_proof.length != 0 && !Fieldval.physical_cleared_conducted && true}
                                                                />
                                                            )}
                                                            validationError={true}
                                                            maxDate={new Date()}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                            </>
                                        }
                                    </div>

                                    <div className="info_div">
                                        <h5>Basic Life Support (CPR)</h5>
                                        <Form.Group
                                            className="mb-3"
                                        >
                                            <Form.Check type="checkbox">
                                                <Form.Check.Input checked={Fieldval?.have_cpr_card ? true : false} name="have_cpr_card" type="checkbox" onChange={(e) => { handleCheckBox(e) }} />
                                                <Form.Check.Label>
                                                    I have a CPR card.
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </Form.Group>

                                        {Fieldval.have_cpr_card
                                            &&
                                            <>
                                                {/* <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    <Form.Label>
                                                        Upload Proof
                                                    </Form.Label>
                                                    <Form.Control name='cpr_proof' type="file" onChange={(e) => { handleDocUpload(e) }} required={Fieldval.have_cpr_card && true} />
                                                    <Form.Text className="text-muted">
                                                        It is valid for 2 year after
                                                        upload.
                                                    </Form.Text>
                                                </Form.Group> */}
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    {Fieldval.cpr_proof.length > 0 &&
                                                        <StudentDocView MapData={Fieldval.cpr_proof} type='cpr' />
                                                    }
                                                    <Form.Label>
                                                        Upload Proof
                                                    </Form.Label>
                                                    <Form.Control name='cpr_proof' type="file" onChange={(e) => { handleDocUpload(e) }}
                                                        required={Fieldval.cpr_proof.length === 0 && true}
                                                    />
                                                    <Form.Text className="text-muted">
                                                        It is valid for an year after
                                                        upload.
                                                    </Form.Text>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterMoment}
                                                    >
                                                        <Form.Label>
                                                            Date when results received
                                                        </Form.Label>
                                                        <DatePicker
                                                            value={Fieldval.cpr_proof_received_date ? Fieldval.cpr_proof_received_date : null}
                                                            placeholder="Enter Date when certificate received"
                                                            className="form-control"
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                newValue &&
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "cpr_proof_received_date": newValue._d
                                                                    })
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    error={Fieldval.cpr_proof && !Fieldval.cpr_proof_received_date && true}
                                                                    helperText={Fieldval.cpr_proof && !Fieldval.cpr_proof_received_date && "*required"}
                                                                    required={Fieldval.cpr_proof.length != 0 && !Fieldval.cpr_proof_received_date && true}
                                                                />
                                                            )}
                                                            maxDate={new Date()}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                            </>
                                        }
                                    </div>

                                    <div className="info_div">
                                        <h5>Background Check</h5>
                                        <Form.Group className="mb-3">
                                            <label className="d-block mb-2">
                                                Did you complete your background
                                                check?
                                            </label>
                                            <Form.Check
                                                inline
                                                label="Cleared"
                                                type="radio"
                                                name="complete_background_check"
                                                id="o1"
                                                value='cleared'
                                                checked={Fieldval && Fieldval.complete_background_check === 'cleared' && true}
                                                onChange={(e) => { handleFieldValue(e) }}
                                                required={!Fieldval.complete_background_check && true}
                                            />
                                            <Form.Check
                                                inline
                                                label="Not Cleared"
                                                type="radio"
                                                name="complete_background_check"
                                                id="o2"
                                                checked={Fieldval && Fieldval.complete_background_check === 'Not cleared' && true}
                                                value='Not cleared'
                                                onChange={(e) => { handleFieldValue(e) }}
                                                required={!Fieldval.complete_background_check && true}
                                            />
                                        </Form.Group>
                                        {Fieldval.complete_background_check === 'cleared' &&
                                            <>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    {Fieldval.complete_background_check_proof.length > 0 &&
                                                        <StudentDocView MapData={Fieldval.complete_background_check_proof} type='background_check_proof' />
                                                    }
                                                    <Form.Label>
                                                        Upload Proof
                                                    </Form.Label>
                                                    <Form.Control name='complete_background_check_proof' type="file" onChange={(e) => { handleDocUpload(e) }}
                                                        required={Fieldval.complete_background_check === 'cleared' && Fieldval.complete_background_check_proof.length === 0 && true}
                                                    />
                                                    <Form.Text className="text-muted">
                                                        It is valid for an year after
                                                        upload.
                                                    </Form.Text>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterMoment}
                                                    >
                                                        <Form.Label>Date</Form.Label>
                                                        <DatePicker
                                                            maxDate={new Date()}
                                                            value={Fieldval.complete_background_check_date ? Fieldval.complete_background_check_date : null}
                                                            placeholder="Enter Date"
                                                            className="form-control"
                                                            name="complete_background_check_date"
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                newValue &&
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "complete_background_check_date": newValue._d
                                                                    })
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    error={Fieldval.complete_background_check_proof && !Fieldval.complete_background_check_date && true}
                                                                    helperText={Fieldval.complete_background_check_proof && !Fieldval.complete_background_check_date && "*required"}
                                                                    required={Fieldval.complete_background_check_proof.length != 0 && !Fieldval.complete_background_check_date && true}
                                                                />
                                                            )}

                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                            </>
                                        }

                                    </div>

                                    <div className="info_div">
                                        <h5>Drug Test</h5>
                                        <Form.Group
                                            className="mb-3"
                                        >
                                            <Form.Check type="checkbox" >
                                                <Form.Check.Input checked={Fieldval?.took_drug_test ? true : false} type="checkbox" name='took_drug_test' onChange={(e) => { handleCheckBox(e) }} />
                                                <Form.Check.Label>
                                                    I declare that I took a drug
                                                    test.
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </Form.Group>
                                        {Fieldval.took_drug_test &&
                                            <>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    {Fieldval.took_drug_test_proof.length > 0 &&
                                                        <StudentDocView MapData={Fieldval.took_drug_test_proof} type='drug_test_proof' />
                                                    }
                                                    <Form.Label>
                                                        Upload Proof
                                                    </Form.Label>
                                                    <Form.Control name='took_drug_test_proof' type="file" onChange={(e) => { handleDocUpload(e) }}
                                                        required={Fieldval.took_drug_test && Fieldval.took_drug_test_proof.length === 0 && true} />
                                                    <Form.Text className="text-muted">
                                                        It is valid for an year after
                                                        upload.
                                                    </Form.Text>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterMoment}
                                                    >
                                                        <Form.Label>
                                                            Date when certificate
                                                            received
                                                        </Form.Label>
                                                        <DatePicker
                                                            maxDate={new Date}
                                                            value={Fieldval.took_drug_test_date ? Fieldval.took_drug_test_date : null}
                                                            placeholder="Enter Date
                                                                                when
                                                                                certificate
                                                                                received"
                                                            className="form-control"
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                newValue &&
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "took_drug_test_date": newValue._d
                                                                    })
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    error={Fieldval.took_drug_test_proof && !Fieldval.took_drug_test_date && true}
                                                                    helperText={Fieldval.took_drug_test_proof && !Fieldval.took_drug_test_date && "*required"}
                                                                    required={Fieldval.took_drug_test_proof && Fieldval.took_drug_test_proof.length > 0 && !Fieldval.took_drug_test_date && true}
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Check
                                                        inline
                                                        label="Positive"
                                                        type="radio"
                                                        name="took_drug_test_result"
                                                        id="o3"
                                                        value="positive"
                                                        checked={Fieldval && Fieldval.took_drug_test_result === 'positive' && true}
                                                        required={Fieldval.took_drug_test && !Fieldval.took_drug_test_result && true}
                                                        onChange={(e) => { handleFieldValue(e) }}
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label="Negative"
                                                        type="radio"
                                                        name="took_drug_test_result"
                                                        checked={Fieldval && Fieldval.took_drug_test_result === 'negative' && true}
                                                        id="o4"
                                                        value="negative"
                                                        onChange={(e) => { handleFieldValue(e) }}
                                                    />
                                                </Form.Group>
                                            </>
                                        }
                                    </div>

                                    <div className="info_div">
                                        <h5>Flu Vaccine</h5>
                                        <Form.Group className="mb-3">
                                            <label className="d-block mb-2">
                                                Did you get the flu vaccine?
                                            </label>
                                            <Form.Check
                                                inline
                                                label="Yes"
                                                type="radio"
                                                name="flu_vaccine_took"
                                                id="05"
                                                value="true"
                                                checked={Fieldval && (Fieldval.flu_vaccine_took === 'true' || Fieldval.flu_vaccine_took === true) && true}
                                                required={!Fieldval.flu_vaccine_took && true}
                                                onChange={(e) => { handleFieldValue(e) }}
                                            />
                                            <Form.Check
                                                inline
                                                label="No"
                                                type="radio"
                                                name="flu_vaccine_took"
                                                value="false"
                                                checked={Fieldval && (Fieldval.flu_vaccine_took === 'false' || Fieldval.flu_vaccine_took === false) && true}
                                                id="06"
                                                onChange={(e) => { handleFieldValue(e) }}
                                            />
                                        </Form.Group>
                                        {
                                            (Fieldval.flu_vaccine_took === 'true' || Fieldval.flu_vaccine_took === true) &&
                                            <>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    {Fieldval.flu_vaccine_proof.length > 0 &&
                                                        <StudentDocView MapData={Fieldval.flu_vaccine_proof} type='flu_vaccine_proof' />
                                                    }
                                                    <Form.Label>
                                                        Upload Proof
                                                    </Form.Label>
                                                    <Form.Control
                                                        name='flu_vaccine_proof' type="file" onChange={(e) => { handleDocUpload(e) }}
                                                        required={Fieldval.flu_vaccine_proof && Fieldval.flu_vaccine_proof.length === 0 && true}
                                                    />
                                                    <Form.Text className="text-muted">
                                                        It is valid for an year after
                                                        upload.
                                                    </Form.Text>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterMoment}
                                                    >
                                                        <Form.Label>
                                                            Date when vaccine received
                                                        </Form.Label>
                                                        <DatePicker
                                                            maxDate={new Date}
                                                            value={Fieldval.flu_vaccine_date ? Fieldval.flu_vaccine_date : null}
                                                            placeholder="Enter Date
                                                                                of
                                                                                test
                                                                                conducted"
                                                            className="form-control"

                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                newValue &&
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "flu_vaccine_date": newValue._d
                                                                    })
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    error={Fieldval.flu_vaccine_proof && Fieldval.flu_vaccine_proof.length > 0 && !Fieldval.flu_vaccine_date && true}
                                                                    helperText={Fieldval.flu_vaccine_proof && Fieldval.flu_vaccine_proof.length > 0 && !Fieldval.flu_vaccine_date && "*required"}
                                                                    required={Fieldval.flu_vaccine_proof && Fieldval.flu_vaccine_proof.length > 0 && !Fieldval.flu_vaccine_date && true}
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Check
                                                        inline
                                                        label="Completed"
                                                        type="radio"
                                                        name="flu_vaccine_status"
                                                        id="o7"
                                                        value='complete'
                                                        checked={Fieldval && Fieldval.flu_vaccine_status === 'complete' && true}
                                                        required={!Fieldval.flu_vaccine_status && true}
                                                        onChange={(e) => { handleFieldValue(e) }}
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label="Not Completed"
                                                        type="radio"
                                                        name="flu_vaccine_status"
                                                        checked={Fieldval && Fieldval.flu_vaccine_status === 'not complete' && true}
                                                        id="o8"
                                                        value='not complete'
                                                        onChange={(e) => { handleFieldValue(e) }}
                                                    />
                                                </Form.Group>
                                            </>


                                        }

                                    </div>

                                    <div className="info_div">
                                        <h5>TB</h5>
                                        <Form.Group className="mb-3">
                                            <label className="d-block mb-2">
                                                Are you positive or negative?
                                            </label>
                                            <Form.Check
                                                inline
                                                label="Positive"
                                                type="radio"
                                                name="tb_result"
                                                id="o9"
                                                value='positive'
                                                checked={Fieldval && Fieldval.tb_result === 'positive' && true}
                                                required={!Fieldval.tb_result && true}
                                                onChange={(e) => { handleFieldValue(e) }}
                                            />
                                            <Form.Check
                                                inline
                                                label="Negative"
                                                type="radio"
                                                name="tb_result"
                                                id="o10"
                                                checked={Fieldval && Fieldval.tb_result === 'negative' && true}
                                                value='negative'
                                                onChange={(e) => { handleFieldValue(e) }}
                                            />
                                        </Form.Group>

                                        {
                                            !Fieldval.td_included_physical_test &&
                                            <>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    {Fieldval.td_xray.length > 0 &&
                                                        <StudentDocView MapData={Fieldval.td_xray} type='tb_xray' />
                                                    }
                                                    <Form.Label>
                                                        Upload X-ray
                                                    </Form.Label>
                                                    <Form.Control name='td_xray' type="file" onChange={(e) => { handleDocUpload(e) }}
                                                    // required={!Fieldval.td_included_physical_test && Fieldval.td_xray.length === 0 && true}
                                                    />
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    {Fieldval.td_document.length > 0 &&
                                                        <StudentDocView MapData={Fieldval.td_document} type='tb_doc' />
                                                    }
                                                    <Form.Label>
                                                        Upload documents
                                                    </Form.Label>
                                                    <Form.Control type="file" name='td_document' onChange={(e) => { handleDocUpload(e) }}
                                                        required={!Fieldval.td_included_physical_test && Fieldval.td_document.length === 0 && true}
                                                    />
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterMoment}
                                                    >
                                                        <Form.Label>
                                                            Date of Tuberculosis test
                                                        </Form.Label>
                                                        <DatePicker
                                                            maxDate={new Date}
                                                            value={Fieldval.td_tuberculosis_test ? Fieldval.td_tuberculosis_test : null}
                                                            // value={Fieldval.td_tuberculosis_test}
                                                            placeholder="Enter Date
                                                                                of
                                                                                test
                                                                                conducted"
                                                            className="form-control"
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                newValue &&
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "td_tuberculosis_test": newValue._d
                                                                    })
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    error={Fieldval.td_document && Fieldval.td_document.length > 0 && !Fieldval.td_tuberculosis_test && true}
                                                                    helperText={Fieldval.td_document && Fieldval.td_document.length > 0 && !Fieldval.td_tuberculosis_test && "*required"}
                                                                    required={Fieldval.td_document && Fieldval.td_document.length > 0 && !Fieldval.td_tuberculosis_test && true}
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                            </>
                                        }


                                        <Form.Group
                                            className="mb-3"
                                        // controlId="formBasicCheckbox"
                                        >
                                            <Form.Check type="checkbox">
                                                <Form.Check.Input name='td_included_physical_test' type="checkbox" onChange={(e) => { handleCheckBox(e) }}
                                                    checked={Fieldval.td_included_physical_test ? true : false}
                                                    required={(Fieldval.td_included_physical_test || Fieldval.tb_result) ? false : true}
                                                />
                                                <Form.Check.Label>
                                                    It is included in the
                                                    Physical Test.
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </Form.Group>
                                    </div>

                                    <div className="info_div">
                                        <h5>MMR</h5>
                                        <Form.Group className="mb-3">
                                            <label className="d-block mb-2">
                                                Are you Immune or non-immune to
                                                MMR?
                                            </label>
                                            <Form.Check
                                                inline
                                                label="Immune"
                                                type="radio"
                                                id="o11"
                                                name='mmr_immunine_status'
                                                checked={Fieldval && Fieldval.mmr_immunine_status === 'immune' && true}
                                                required={!Fieldval.mmr_immunine_status && true}
                                                value='immune'
                                                onChange={(e) => { handleFieldValue(e) }}
                                            />
                                            <Form.Check
                                                inline
                                                label="Non-Immune"
                                                type="radio"
                                                id="o12"
                                                name='mmr_immunine_status'
                                                checked={Fieldval && Fieldval.mmr_immunine_status === 'non-immune' && true}
                                                value='non-immune'
                                                onChange={(e) => { handleFieldValue(e) }}

                                            />
                                        </Form.Group>
                                        {Fieldval.mmr_immunine_status === 'immune' &&
                                            <>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterMoment}
                                                    >
                                                        <Form.Label>
                                                            Date you got your 1st
                                                            booster
                                                        </Form.Label>
                                                        <DatePicker
                                                            maxDate={new Date}
                                                            value={Fieldval.mmr_booster_dose1_date ? Fieldval.mmr_booster_dose1_date : null}
                                                            placeholder="Enter Date you got your 1st booster"
                                                            className="form-control"
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                newValue &&
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "mmr_booster_dose1_date": newValue._d
                                                                    })
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    error={Fieldval.mmr_immunine_status && Fieldval.mmr_immunine_status === 'immune' && !Fieldval.mmr_booster_dose1_date && true}
                                                                    helperText={Fieldval.mmr_immunine_status && Fieldval.mmr_immunine_status === 'immune' && !Fieldval.mmr_booster_dose1_date && "*required"}
                                                                    required={Fieldval.mmr_immunine_status && Fieldval.mmr_immunine_status === 'immune' && !Fieldval.mmr_booster_dose1_date && true}
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>

                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterMoment}
                                                    >
                                                        <Form.Label>
                                                            Date of 2nd dose
                                                        </Form.Label>
                                                        <DatePicker
                                                            maxDate={new Date}
                                                            value={Fieldval.mmr_booster_dose2_date ? Fieldval.mmr_booster_dose2_date : null}
                                                            placeholder="Enter Date of 2nd dose"
                                                            className="form-control"
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                newValue &&
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "mmr_booster_dose2_date": newValue._d
                                                                    })
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    error={Fieldval.mmr_immunine_status && Fieldval.mmr_immunine_status === 'immune' && !Fieldval.mmr_booster_dose2_date && true}
                                                                    helperText={Fieldval.mmr_immunine_status && Fieldval.mmr_immunine_status === 'immune' && !Fieldval.mmr_booster_dose2_date && "*required"}
                                                                    required={Fieldval.mmr_immunine_status && Fieldval.mmr_immunine_status === 'immune' && !Fieldval.mmr_booster_dose2_date && true}
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    {Fieldval.mmr_booster_dose2_proof.length > 0 &&
                                                        <StudentDocView MapData={Fieldval.mmr_booster_dose2_proof} type='mmr_proof' />
                                                    }
                                                    <Form.Label>
                                                        Upload Proof of 2nd dose
                                                    </Form.Label>
                                                    <Form.Control name='mmr_booster_dose2_proof' type="file" onChange={(e) => { handleDocUpload(e) }}
                                                        required={Fieldval.mmr_immunine_status && Fieldval.mmr_booster_dose2_date && Fieldval.mmr_booster_dose2_proof.length === 0 && true} />
                                                </Form.Group>

                                                <Form.Group
                                                    className="mb-3"
                                                // controlId="formBasicCheckbox"
                                                >
                                                    <Form.Check type="checkbox">
                                                        <Form.Check.Input type="checkbox" name='mmr_non_completed' onChange={(e) => { handleCheckBox(e) }} />
                                                        <Form.Check.Label>
                                                            Non Completed.
                                                        </Form.Check.Label>
                                                    </Form.Check>
                                                </Form.Group>
                                            </>
                                        }

                                    </div>

                                    <div className="info_div">
                                        <h5>Varicella</h5>
                                        <Form.Group className="mb-3">
                                            <label className="d-block mb-2">
                                                Are you Immune or non-immune to
                                                Varicella?
                                            </label>
                                            <Form.Check
                                                inline
                                                label="Immune"
                                                type="radio"
                                                name="varicella_immunine_status"
                                                value='immune'
                                                checked={Fieldval && Fieldval.varicella_immunine_status === 'immune' && true}
                                                required={!Fieldval.varicella_immunine_status && true}
                                                onChange={(e) => { handleFieldValue(e) }}
                                                id="o13"
                                            />
                                            <Form.Check
                                                inline
                                                label="Non-Immune"
                                                type="radio"
                                                name="varicella_immunine_status"
                                                checked={Fieldval && Fieldval.varicella_immunine_status === 'non-immune' && true}
                                                value='non-immune'
                                                onChange={(e) => { handleFieldValue(e) }}
                                                id="o14"
                                            />
                                        </Form.Group>
                                        {Fieldval.varicella_immunine_status === 'immune' &&
                                            <>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterMoment}
                                                    >
                                                        <Form.Label>
                                                            Date you got your 1st
                                                            booster
                                                        </Form.Label>
                                                        <DatePicker
                                                            maxDate={new Date}
                                                            value={Fieldval.varicella_booster_dose1_date ? Fieldval.varicella_booster_dose1_date : null}
                                                            placeholder="Enter Date you got your 1st booster"
                                                            className="form-control"
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                newValue &&
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "varicella_booster_dose1_date": newValue._d
                                                                    })
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    error={Fieldval.varicella_immunine_status && Fieldval.varicella_immunine_status === 'immune' && !Fieldval.varicella_booster_dose1_date && true}
                                                                    helperText={Fieldval.varicella_immunine_status && Fieldval.varicella_immunine_status === 'immune' && !Fieldval.varicella_booster_dose1_date && "*required"}
                                                                    required={Fieldval.varicella_immunine_status && Fieldval.varicella_immunine_status === 'immune' && !Fieldval.varicella_booster_dose1_date && true}
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterMoment}
                                                    >
                                                        <Form.Label>
                                                            Date of 2nd dose
                                                        </Form.Label>
                                                        <DatePicker
                                                            maxDate={new Date}
                                                            value={Fieldval.varicella_booster_dose2_date ? Fieldval.varicella_booster_dose2_date : null}
                                                            placeholder="Enter Date of 2nd dose"
                                                            className="form-control"
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                newValue &&
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "varicella_booster_dose2_date": newValue._d
                                                                    })
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    error={Fieldval.varicella_immunine_status && Fieldval.varicella_immunine_status === 'immune' && !Fieldval.varicella_booster_dose2_date && true}
                                                                    helperText={Fieldval.varicella_immunine_status && Fieldval.varicella_immunine_status === 'immune' && !Fieldval.varicella_booster_dose2_date && "*required"}
                                                                    required={Fieldval.varicella_immunine_status && Fieldval.varicella_immunine_status === 'immune' && !Fieldval.varicella_booster_dose2_date && true}
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    {Fieldval.varicella_booster_dose2_proof.length > 0 &&
                                                        <StudentDocView MapData={Fieldval.varicella_booster_dose2_proof} type='varicella_proof' />
                                                    }
                                                    <Form.Label>
                                                        Upload Proof of 2nd dose
                                                    </Form.Label>
                                                    <Form.Control name='varicella_booster_dose2_proof' type="file" onChange={(e) => { handleDocUpload(e) }}
                                                        required={Fieldval.varicella_immunine_status === 'immune' && Fieldval.varicella_booster_dose2_date && Fieldval.varicella_booster_dose2_proof.length === 0 && true} />
                                                </Form.Group>
                                                <Form.Group
                                                    className="mb-3"
                                                // controlId="formBasicCheckbox"
                                                >
                                                    <Form.Check type="checkbox" name='varicella_non_completed' onChange={(e) => { handleCheckBox(e) }}>
                                                        <Form.Check.Input type="checkbox" />
                                                        <Form.Check.Label>
                                                            Non Completed.
                                                        </Form.Check.Label>
                                                    </Form.Check>
                                                </Form.Group>
                                            </>
                                        }
                                    </div>

                                    <div className="info_div">
                                        <h5>Hep B</h5>
                                        <Form.Group className="mb-3">
                                            <label className="d-block mb-2">
                                                Are you Immune or non-immune to
                                                Hep B?
                                            </label>
                                            <Form.Check
                                                inline
                                                label="Immune"
                                                type="radio"
                                                name="hep_b_immunine_status"
                                                checked={Fieldval && Fieldval.hep_b_immunine_status === 'immune' && true}
                                                required={!Fieldval.hep_b_immunine_status && true}
                                                value='immune'
                                                onChange={(e) => { handleFieldValue(e) }}
                                                id="o15"
                                            />
                                            <Form.Check
                                                inline
                                                label="Non-Immune"
                                                type="radio"
                                                name="hep_b_immunine_status"
                                                checked={Fieldval && Fieldval.hep_b_immunine_status === 'non-immune' && true}
                                                value='non-immune'
                                                onChange={(e) => { handleFieldValue(e) }}
                                                id="o16"
                                            />
                                        </Form.Group>
                                        {Fieldval.hep_b_immunine_status === 'immune' &&
                                            <>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterMoment}
                                                    >
                                                        <Form.Label>
                                                            Date you got your 1st
                                                            booster
                                                        </Form.Label>
                                                        <DatePicker
                                                            maxDate={new Date}
                                                            value={Fieldval.hep_b_booster_dose1_date ? Fieldval.hep_b_booster_dose1_date : null}
                                                            placeholder="Enter Date you got your 1st booster"
                                                            className="form-control"
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                newValue &&
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "hep_b_booster_dose1_date": newValue._d
                                                                    })
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    error={Fieldval.hep_b_immunine_status && Fieldval.hep_b_immunine_status === 'immune' && !Fieldval.hep_b_booster_dose1_date && true}
                                                                    helperText={Fieldval.hep_b_immunine_status && Fieldval.hep_b_immunine_status === 'immune' && !Fieldval.hep_b_booster_dose1_date && "*required"}
                                                                    required={Fieldval.hep_b_immunine_status && Fieldval.hep_b_immunine_status === 'immune' && !Fieldval.hep_b_booster_dose1_date && true}
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterMoment}
                                                    >
                                                        <Form.Label>
                                                            Date of 2nd dose
                                                        </Form.Label>
                                                        <DatePicker
                                                            maxDate={new Date}
                                                            value={Fieldval.hep_b_booster_dose2_date ? Fieldval.hep_b_booster_dose2_date : null}
                                                            placeholder="Enter Date of 2nd dose"
                                                            className="form-control"
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                newValue &&
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "hep_b_booster_dose2_date": newValue._d
                                                                    })
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    error={Fieldval.hep_b_immunine_status && Fieldval.hep_b_immunine_status === 'immune' && !Fieldval.hep_b_booster_dose2_date && true}
                                                                    helperText={Fieldval.hep_b_immunine_status && Fieldval.hep_b_immunine_status === 'immune' && !Fieldval.hep_b_booster_dose2_date && "*required"}
                                                                    required={Fieldval.hep_b_immunine_status && Fieldval.hep_b_immunine_status === 'immune' && !Fieldval.hep_b_booster_dose2_date && true}
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    {Fieldval.hep_b_booster_dose2_proof.length > 0 &&
                                                        <StudentDocView MapData={Fieldval.hep_b_booster_dose2_proof} type='hep_b_proof' />
                                                    }
                                                    <Form.Label>
                                                        Upload Proof of 2nd dose
                                                    </Form.Label>
                                                    <Form.Control name='hep_b_booster_dose2_proof' type="file" onChange={(e) => { handleDocUpload(e) }}
                                                        required={Fieldval.hep_b_booster_dose2_proof && Fieldval.hep_b_booster_dose2_date && Fieldval.hep_b_booster_dose2_proof.length === 0 && true} />
                                                </Form.Group>

                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterMoment}
                                                    >
                                                        <Form.Label>
                                                            Date of 3rd dose
                                                        </Form.Label>
                                                        <DatePicker
                                                            maxDate={new Date}
                                                            value={Fieldval.hep_b_booster_dose3_date ? Fieldval.hep_b_booster_dose3_date : null}
                                                            placeholder="Enter Date of 2nd dose"
                                                            className="form-control"
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                newValue &&
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "hep_b_booster_dose3_date": newValue._d
                                                                    })
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    error={Fieldval.hep_b_immunine_status && Fieldval.hep_b_immunine_status === 'immune' && !Fieldval.hep_b_booster_dose3_date && true}
                                                                    helperText={Fieldval.hep_b_immunine_status && Fieldval.hep_b_immunine_status === 'immune' && !Fieldval.hep_b_booster_dose3_date && "*required"}
                                                                    required={Fieldval.hep_b_immunine_status && Fieldval.hep_b_immunine_status === 'immune' && !Fieldval.hep_b_booster_dose3_date && true}
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    {Fieldval.hep_b_booster_dose3_proof.length > 0 &&
                                                        <StudentDocView MapData={Fieldval.hep_b_booster_dose3_proof} type='hep_b_proof' />
                                                    }
                                                    <Form.Label>
                                                        Upload Proof of 3rd dose
                                                    </Form.Label>
                                                    <Form.Control name='hep_b_booster_dose3_proof' type="file" onChange={(e) => { handleDocUpload(e) }}
                                                        required={Fieldval.hep_b_booster_dose3_proof && Fieldval.hep_b_booster_dose3_date && Fieldval.hep_b_booster_dose3_proof.length === 0 && true} />
                                                </Form.Group>

                                                <Form.Group
                                                    className="mb-3"
                                                // controlId="formBasicCheckbox"
                                                >
                                                    <Form.Check type="checkbox">
                                                        <Form.Check.Input type="checkbox" name='hep_b_non_completed' onChange={(e) => { handleCheckBox(e) }} />
                                                        <Form.Check.Label>
                                                            Non Completed.
                                                        </Form.Check.Label>
                                                    </Form.Check>
                                                </Form.Group>
                                            </>
                                        }

                                    </div>

                                    <div className="info_div">
                                        <h5>Covid-19</h5>
                                        <Form.Group className="mb-3">
                                            <label className="d-block mb-2">
                                                Are you vaccinated for COVID?
                                            </label>
                                            <Form.Check
                                                inline
                                                label="Yes"
                                                type="radio"
                                                name="covid_vaccinated"
                                                value='true'
                                                checked={Fieldval && (Fieldval.covid_vaccinated === 'true' || Fieldval.covid_vaccinated === true) && true}
                                                required={!Fieldval.covid_vaccinated && true}
                                                onChange={(e) => { handleFieldValue(e) }}
                                                id="o17"
                                            />
                                            <Form.Check
                                                inline
                                                label="No"
                                                type="radio"
                                                checked={Fieldval && (Fieldval.covid_vaccinated === 'false' || Fieldval.covid_vaccinated === false) && true}
                                                name="covid_vaccinated"
                                                value='false'
                                                onChange={(e) => { handleFieldValue(e) }}
                                                id="o18"
                                            />
                                        </Form.Group>
                                        {(Fieldval.covid_vaccinated === 'true' || Fieldval.covid_vaccinated === true) &&
                                            <>
                                                {console.log(booster, "booster")}
                                                <Form.Group
                                                    className="mb-3"
                                                    controlId="exampleForm.ControlTextarea1"
                                                >
                                                    <Form.Label>
                                                        How many boosters?
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        defaultValue={Fieldval && Fieldval.covid_no_of_booster && Fieldval.covid_no_of_booster}
                                                        name='covid_no_of_booster'
                                                        placeholder="Enter the number of boosters"
                                                        onChange={(e) => {
                                                            handleFieldValue(e)
                                                            if (e.target.value > 1) {
                                                                setBooster(true)
                                                            }
                                                            else {
                                                                setBooster(false)
                                                            }
                                                        }}
                                                        required={Fieldval.covid_vaccinated && !Fieldval.covid_no_of_booster && true}

                                                    />
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterMoment}
                                                    >
                                                        <Form.Label>
                                                            Date of 1st booster
                                                        </Form.Label>
                                                        <DatePicker
                                                            maxDate={new Date}
                                                            value={Fieldval.covid_booster_dose1_date ? Fieldval.covid_booster_dose1_date : null}
                                                            placeholder="Enter Date
                                                                                of
                                                                                1st
                                                                                booster"
                                                            className="form-control"
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                newValue &&
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "covid_booster_dose1_date": newValue._d
                                                                    })
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    {...params}
                                                                    error={Fieldval.covid_vaccinated && Fieldval.covid_vaccinated === 'true' && !Fieldval.covid_booster_dose1_date && true}
                                                                    helperText={Fieldval.covid_vaccinated && Fieldval.covid_vaccinated === 'true' && !Fieldval.covid_booster_dose1_date && "*required"}
                                                                    required={Fieldval.covid_vaccinated && Fieldval.covid_vaccinated === 'true' && !Fieldval.covid_booster_dose1_date && true}
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterMoment}
                                                    >
                                                        <Form.Label>
                                                            Date of 2nd booster
                                                        </Form.Label>
                                                        <DatePicker
                                                            maxDate={new Date}
                                                            value={Fieldval.covid_booster_dose2_date ? Fieldval.covid_booster_dose2_date : null}
                                                            placeholder="Enter Date
                                                                                of
                                                                                2nd
                                                                                booster"
                                                            className="form-control"
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                newValue &&
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "covid_booster_dose2_date": newValue._d
                                                                    })
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    {...params}
                                                                    error={Fieldval.covid_vaccinated && Fieldval.covid_vaccinated === 'true' && booster && !Fieldval.covid_booster_dose2_date && true}
                                                                    helperText={Fieldval.covid_vaccinated && Fieldval.covid_vaccinated === 'true' && booster && !Fieldval.covid_booster_dose2_date && "*required"}
                                                                    required={Fieldval.covid_vaccinated && Fieldval.covid_vaccinated === 'true' && booster && !Fieldval.covid_booster_dose2_date && true}
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    {Fieldval.covid_proof.length > 0 &&
                                                        <StudentDocView MapData={Fieldval.covid_proof} type='covid_19' />
                                                    }
                                                    <Form.Label>
                                                        Upload Proof
                                                    </Form.Label>
                                                    <Form.Control name='covid_proof' type="file" onChange={(e) => { handleDocUpload(e) }}
                                                        required={Fieldval.covid_vaccinated && Fieldval.covid_proof.length === 0 && true} />
                                                </Form.Group>

                                                <Form.Group
                                                    className="mb-3"
                                                // controlId="formBasicCheckbox"
                                                >
                                                    <Form.Check type="checkbox">
                                                        <Form.Check.Input type="checkbox" name='covid_non_completed' onChange={(e) => { handleCheckBox(e) }} />
                                                        <Form.Check.Label>
                                                            Non Completed.
                                                        </Form.Check.Label>
                                                    </Form.Check>
                                                </Form.Group>
                                            </>

                                        }

                                    </div>


                                    <div className="info_div">
                                        <h5>Fittested</h5>
                                        <Form.Group className="mb-3">
                                            <label className="d-block mb-2">
                                                Have you been Fittested?
                                            </label>
                                            <Form.Check
                                                inline
                                                label="Yes"
                                                type="radio"
                                                name="been_fittested"
                                                checked={Fieldval && (Fieldval.been_fittested === 'true' || Fieldval.been_fittested === true) && true}
                                                required={!Fieldval.been_fittested && true}
                                                value='true'
                                                onChange={(e) => { handleFieldValue(e) }}
                                                id="o19"
                                            />
                                            <Form.Check
                                                inline
                                                label="No"
                                                type="radio"
                                                name="been_fittested"
                                                checked={Fieldval && (Fieldval.been_fittested === 'false' || Fieldval.been_fittested === false) && true}
                                                onChange={(e) => { handleFieldValue(e) }}
                                                value='false'
                                                id="o20"
                                            />
                                        </Form.Group>
                                        {(Fieldval.been_fittested === 'true' || Fieldval.been_fittested === true) &&
                                            <Form.Group
                                                controlId="formFile"
                                                className="mb-3 mui_dtpickr"
                                            >
                                                <LocalizationProvider
                                                    dateAdapter={AdapterMoment}
                                                >
                                                    <Form.Label>Date</Form.Label>
                                                    <DatePicker
                                                        maxDate={new Date}
                                                        value={Fieldval.fittested_date ? Fieldval.fittested_date : null}
                                                        placeholder="Enter Date"
                                                        className="form-control"
                                                        onChange={(
                                                            newValue
                                                        ) => {
                                                            newValue &&
                                                                SetFieldVal({
                                                                    ...Fieldval,
                                                                    "fittested_date": newValue._d
                                                                })
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                error={Fieldval.been_fittested && Fieldval.been_fittested === 'true' && !Fieldval.fittested_date && true}
                                                                helperText={Fieldval.been_fittested && Fieldval.been_fittested === 'true' && !Fieldval.fittested_date && "*required"}
                                                                required={Fieldval.been_fittested && Fieldval.been_fittested === 'true' && !Fieldval.fittested_date && true}
                                                            />
                                                        )}
                                                    />
                                                </LocalizationProvider>
                                            </Form.Group>
                                        }
                                    </div>

                                    <div className="info_div">
                                        <h5>LA fire safety card</h5>
                                        <Form.Group className="mb-3">
                                            <label className="d-block mb-2">
                                                Do you have an LA fire safety
                                                card?
                                            </label>
                                            <Form.Check
                                                inline
                                                label="Yes"
                                                type="radio"
                                                name="la_fire_safety_card"
                                                checked={Fieldval && (Fieldval.la_fire_safety_card === 'true' || Fieldval.la_fire_safety_card === true) && true}
                                                required={!Fieldval.la_fire_safety_card && true}
                                                value='true'
                                                onChange={(e) => { handleFieldValue(e) }}
                                                id="o21"
                                            />
                                            <Form.Check
                                                inline
                                                label="No"
                                                type="radio"
                                                checked={Fieldval && (Fieldval.la_fire_safety_card === 'false' || Fieldval.la_fire_safety_card === false) && true}
                                                name="la_fire_safety_card"
                                                value='false'
                                                onChange={(e) => { handleFieldValue(e) }}
                                                id="o22"
                                            />
                                        </Form.Group>
                                        {(Fieldval.la_fire_safety_card === 'true' || Fieldval.la_fire_safety_card === true) &&
                                            <>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterMoment}
                                                    >
                                                        <Form.Label>Date</Form.Label>
                                                        <DatePicker
                                                            maxDate={new Date}
                                                            value={Fieldval.la_fire_safety_card_date ? Fieldval.la_fire_safety_card_date : null}
                                                            placeholder="Enter Date"
                                                            className="form-control"
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                newValue &&
                                                                    SetFieldVal({
                                                                        ...Fieldval,
                                                                        "la_fire_safety_card_date": newValue._d
                                                                    })
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    error={Fieldval.la_fire_safety_card && Fieldval.la_fire_safety_card === 'true' && !Fieldval.la_fire_safety_card_date && true}
                                                                    helperText={Fieldval.la_fire_safety_card && Fieldval.la_fire_safety_card === 'true' && !Fieldval.la_fire_safety_card_date && "*required"}
                                                                    required={Fieldval.la_fire_safety_card && Fieldval.la_fire_safety_card === 'true' && !Fieldval.la_fire_safety_card_date && true}
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    {Fieldval.la_fire_safety_proof.length > 0 &&
                                                        <StudentDocView MapData={Fieldval.la_fire_safety_proof} type='LA_fire_safety_proof' />
                                                    }
                                                    <Form.Label>
                                                        Upload Proof
                                                    </Form.Label>
                                                    <Form.Control type="file" name='la_fire_safety_proof' onChange={(e) => { handleDocUpload(e) }}
                                                        required={Fieldval.la_fire_safety_card && Fieldval.la_fire_safety_proof.length === 0 && true} />
                                                </Form.Group>
                                            </>
                                        }

                                    </div>

                                    <div className="info_div">
                                        <h5>Additional Info</h5>
                                        <Form.Group className="mb-3">
                                            <label className="d-block mb-2">
                                                Do you have anything additional
                                                infos to share?
                                            </label>
                                            <Form.Check
                                                inline
                                                label="Yes"
                                                type="radio"
                                                checked={Fieldval && (Fieldval.is_additional_info_share === 'true' || Fieldval.is_additional_info_share === true) && true}
                                                required={!Fieldval.is_additional_info_share && true}
                                                value='true'
                                                name="is_additional_info_share"
                                                onChange={(e) => { handleFieldValue(e) }}
                                                id="o23"
                                            />
                                            <Form.Check
                                                inline
                                                label="No"
                                                type="radio"
                                                checked={Fieldval && (Fieldval.is_additional_info_share === 'false' || Fieldval.is_additional_info_share === false) && true}
                                                value='false'
                                                name="is_additional_info_share"
                                                onChange={(e) => { handleFieldValue(e) }}
                                                id="o24"
                                            />
                                        </Form.Group>
                                        {(Fieldval.is_additional_info_share === 'true' || Fieldval.is_additional_info_share === true) &&
                                            <>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    {Fieldval.additional_info_proof.length > 0 &&
                                                        <StudentDocView MapData={Fieldval.additional_info_proof} type='additional_proof' />
                                                    }
                                                    <Form.Label>
                                                        Upload Proof Additional Info 1
                                                    </Form.Label>
                                                    <Form.Control type="file" name='additional_info_proof' onChange={(e) => { handleDocUpload(e) }}
                                                        required={Fieldval.is_additional_info_share && Fieldval.additional_info_proof.length === 0 && true} />
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    <Form.Label>
                                                        Description of Info 1
                                                    </Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        value={Fieldval.additional_info_comment1 && Fieldval.additional_info_comment1}
                                                        name="additional_info_comment1"
                                                        onChange={(e) => { handleFieldValue(e) }}
                                                        required
                                                    />
                                                </Form.Group>

                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    {Fieldval.additional_info_proof2.length > 0 &&
                                                        <StudentDocView MapData={Fieldval.additional_info_proof2} type='additional_proof' />
                                                    }
                                                    <Form.Label>
                                                        Upload Proof Additional Info 2
                                                    </Form.Label>
                                                    <Form.Control type="file" name='additional_info_proof2' onChange={(e) => { handleDocUpload(e) }}
                                                    // required={Fieldval.is_additional_info_share && Fieldval.additional_info_proof2.length === 0 && true}
                                                    />
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >

                                                    <Form.Label>
                                                        Description of Info 2
                                                    </Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        value={Fieldval.additional_info_comment2 && Fieldval.additional_info_comment2}
                                                        name="additional_info_comment2"
                                                        onChange={(e) => { handleFieldValue(e) }}

                                                    />
                                                </Form.Group>



                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    {Fieldval.additional_info_proof3.length > 0 &&
                                                        <StudentDocView MapData={Fieldval.additional_info_proof3} type='additional_proof' />
                                                    }
                                                    <Form.Label>
                                                        Upload Proof Additional Info 3
                                                    </Form.Label>
                                                    <Form.Control type="file" name='additional_info_proof3' onChange={(e) => { handleDocUpload(e) }}
                                                    // required={Fieldval.additional_info_proof3 && Fieldval.additional_info_proof3.length === 0 && true}
                                                    />
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    <Form.Label>
                                                        Description of Info 3
                                                    </Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        value={Fieldval.additional_info_comment3 && Fieldval.additional_info_comment3}
                                                        name="additional_info_comment3"
                                                        onChange={(e) => { handleFieldValue(e) }}

                                                    />
                                                </Form.Group>
                                            </>
                                        }

                                    </div>

                                    <Button
                                        className="btn_theme w-100 mt-4"
                                        type="submit"
                                        variant=""
                                    >
                                        Continue
                                    </Button>
                                </Form>
                            </div>
                        </Col>
                        <RightSidebar step={4} />
                    </Row>
                </div>
            </Container>
        </div>
    );
};

export default StudentInfo2;
